import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserSettingsService } from 'api';

import { NotificationProps } from 'models';

export const notifications = createAsyncThunk(
	'userSettings/notifications',
	async (credentials: NotificationProps, { rejectWithValue }) => {
		try {
			await UserSettingsService.notification(credentials);
			return await UserSettingsService.get();
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
